import axios from "axios";
import { authorization } from "./SharedFunctions";
import { data } from "jquery";

const getUserProfileInfo = (token) => {
  return axios.post("/profile_full", {}, authorization(token));
};

const getTodayDate = (token) => {
  return axios.post("/today", {}, authorization(token));
};

const changePassword = (data, token) => {
  return axios.post("/substitute", data, authorization(token));
};

const dashboardMine = (token) => {
  return axios.post("/dashboard_mine", {}, authorization(token));
};

const addDashboard = (data, token) => {
  return axios.post("/dashboard_new", data, authorization(token));
};

const renameDashboardApi = (data, token) => {
  return axios.post("/dashboard_rename", data, authorization(token));
};

const dashboardZone = (data, token) => {
  return axios.post("/dashboard_zones", data, authorization(token));
};

const dashboardRemove = (data, token) => {
  return axios.post("/dashboard_remove", data, authorization(token));
};

const addZone = (data, token) => {
  return axios.post("/zone_new", data, authorization(token));
};

const renameZone = (data, token) => {
  return axios.post("/zone_rename", data, authorization(token));
};

const zoneWidgets = (data, token) => {
  return axios.post("/zone_widgets", data, authorization(token));
};

const zoneRemove = (data, token) => {
  return axios.post("/zone_remove", data, authorization(token));
};

const relocateWidget = (data, token) => {
  return axios.post("/widget_relocate", data, authorization(token));
};

const renameWidget = (data, token) => {
  return axios.post("/widget_rename", data, authorization(token));
};

const redressWidget = (data, token) => {
  return axios.post("/widget_redress", data, authorization(token));
};

const visibleWidget = (data, token) => {
  return axios.post("/widget_visible", data, authorization(token));
};

const deviceWidgetsDisjoined = (data, token) => {
  return axios.post("/device_widgets_disjoined", data, authorization(token));
};

const deviceJoin = (data, token) => {
  return axios.post("/device_join", data, authorization(token));
};

const deviceWidgetsJoinedApi = (data, token) => {
  return axios.post("/device_widgets_joined", data, authorization(token));
};

const deviceMineApi = (token) => {
  return axios.post("/device_mine", {}, authorization(token));
};

const deviceRenameApi = (data, token) => {
  return axios.post("/device_rename", data, authorization(token));
};

const getCommandGeneralApi = (token) => {
  return axios.post("/command_general", {}, authorization(token));
};

const invitationListApi = (token) => {
  return axios.post("/invitation_list", {}, authorization(token));
};

const invitationNewApi = (data, token) => {
  return axios.post("/invitation_new", data, authorization(token));
};

const invitationAuthorityGet = (data, token) => {
  return axios.post("/invitation_authority_get", data, authorization(token));
};

const invitationAuthoritySet = (data, token) => {
  return axios.post("/invitation_authority_set", data, authorization(token));
};

const getFolioList = (token) => {
  return axios.post("/folio_list", {}, authorization(token));
};

const getFolio = (data, token) => {
  return axios.post("/folio_get", data, authorization(token));
};

const getSupportTypeList = (token) => {
  return axios.post("/support_type_list", {}, authorization(token));
};

const setNewSupport = (data, token) => {
  return axios.post("/support_new", data, authorization(token));
};

const getSupportMine = (token) => {
  return axios.post("/support_mine", {}, authorization(token));
};

const getWidgetCommandsApi = (data, token) => {
  return axios.post("/widget_commands", data, authorization(token));
};

const setNewSchedule = (data, token) => {
  return axios.post("/schedule_new", data, authorization(token));
};

const getScheduleListApi = (data, token) => {
  return axios.post("/schedule_list", data, authorization(token));
};

const scheduleEditApi = (data, token) => {
  return axios.post("/schedule_edit", data, authorization(token));
};

const scheduleDeleteApi = (data, token) => {
  return axios.post("/schedule_remove", data, authorization(token));
};

const getIconsApi = (token) => {
  return axios.post("/icons", {}, authorization(token));
};

const profileUpdateApi = (data, token) => {
  return axios.post("/profile_update", data, authorization(token));
};

const profileImageUpdateApi = (data, token) => {
  return axios.post("/upload_profile_image", data, authorization(token));
};

const removeLearnApi = (data, token) => {
  return axios.post("/widget_withdraw", data, authorization(token));
};
const addNewScenario = (data, token) => {
  return axios.post("/scenario_new", data, authorization(token));
};
const scenariosList = (token) => {
  return axios.post("/scenario_list", {}, authorization(token));
};
const scenarioExe = (data, token) => {
  return axios.post("/scenariocommand_add", data, authorization(token));
};
const scenarioEdit = (data, token) => {
  return axios.post("/scenario_edit", data, authorization(token));
};
const scenarioDelete = (data, token) => {
  return axios.post("/scenario_remove", data, authorization(token));
};
const scenarioAddWidget = (data, token) => {
  return axios.post("/scenariowg_new", data, authorization(token));
};
const scenarioListWidget = (data, token) => {
  return axios.post("/scenariowg_list", data, authorization(token));
};
const scenarioWidgetExtraList = (data, token) => {
  return axios.post("/scenariowgapp_list", data, authorization(token));
};
const scenarioWidgetEdit = (data, token) => {
  return axios.post("/scenariowg_edit", data, authorization(token));
};
const limitList = (token) => {
  return axios.post("/limitation_list", {}, authorization(token));
};
const addNewAutomation = (data, token) => {
  return axios.post("/automation_new", data, authorization(token));
};
const automationList = (token) => {
  return axios.post("/automation_list", {}, authorization(token));
};
const deleteAutomation = (data, token) => {
  return axios.post("/automation_remove", data, authorization(token));
};
const EditAutomation = (data, token) => {
  return axios.post("/automation_edit", data, authorization(token));
};

const automationAddWidget = (data, token) => {
  return axios.post("/automationwg_new", data, authorization(token));
};
const automationWidgetList = (data, token) => {
  return axios.post("/automationwg_list", data, authorization(token));
};

export {
  getUserProfileInfo,
  getTodayDate,
  changePassword,
  dashboardMine,
  dashboardZone,
  addZone,
  zoneWidgets,
  addDashboard,
  renameZone,
  deviceJoin,
  deviceWidgetsDisjoined,
  deviceWidgetsJoinedApi,
  invitationListApi,
  invitationAuthorityGet,
  invitationAuthoritySet,
  invitationNewApi,
  getFolioList,
  getFolio,
  getSupportTypeList,
  setNewSupport,
  getSupportMine,
  getWidgetCommandsApi,
  setNewSchedule,
  getScheduleListApi,
  scheduleEditApi,
  scheduleDeleteApi,
  relocateWidget,
  renameWidget,
  visibleWidget,
  deviceMineApi,
  deviceRenameApi,
  getCommandGeneralApi,
  renameDashboardApi,
  zoneRemove,
  dashboardRemove,
  getIconsApi,
  redressWidget,
  profileUpdateApi,
  profileImageUpdateApi,
  removeLearnApi,
  addNewScenario,
  scenariosList,
  scenarioExe,
  scenarioEdit,
  scenarioDelete,
  scenarioAddWidget,
  scenarioListWidget,
  scenarioWidgetExtraList,
  scenarioWidgetEdit,
  limitList,
  addNewAutomation,
  automationList,
  deleteAutomation,
  EditAutomation,
  automationAddWidget,
  automationWidgetList,
};
